exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".general-dropdown-toggle{border:0 !important;background:rgba(0,0,0,0);color:#999 !important;white-space:normal;text-align:left}.general-dropdown-label-container{display:flex}.general-dropdown-label{color:#999;align-self:center}.dropdown-item{color:#999}.dropdown-item:hover{color:#ffc000;text-decoration:none;background-color:#111}.btn-secondary:not(:disabled):not(.disabled).active,.btn-secondary:not(:disabled):not(.disabled):active,.show>.btn-secondary.dropdown-toggle{background-color:#000}.custom-category-input{color:#999;border:0}.category-dropdown-toggle{width:100%;color:#bbb7b7;background-color:#2b2a2a;border:1px solid #999}.general-dropdown-item{white-space:normal}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/forms/GeneralMultiItemDropDown/styles.scss
// module id = 752
// module chunks = 0